module.exports = __webpack_public_path__ + "img/download2.d622b16e.svg";